import { isDefined } from "../../utils/isDefined";
export function getItemNodeFormatting(column, values) {
    const formatter = (value) => {
        if (isDefined(value) && column?.formatter) {
            return column?.formatter(value);
        }
        return value;
    };
    return formatter(values[column.key]);
}
export function getBoolValueFromRow(item, row) {
    const getValue = (disabled) => {
        if (disabled === undefined)
            return false;
        if (typeof disabled === "boolean")
            return disabled;
        return isDefined(item) && disabled(item);
    };
    return Boolean(getValue(row));
}
export function tableHasAction(props) {
    return [props.link, props.onSelect, props.linkBuilder].some((p) => isDefined(p));
}
export function rowHasAction(item, tableProps) {
    if (tableProps.linkBuilder) {
        return tableProps.linkBuilder(item) !== null;
    }
    return [tableProps.link, tableProps.onSelect, tableProps.dropdown].some((p) => isDefined(p));
}
export function getTableHasDropdown(props) {
    return isDefined(props?.dropdown) && props?.form?.viewState !== "edit";
}
export function getTableHasCheckboxSelection(props) {
    return isDefined(props?.form?.type) && props?.form?.type === "checkbox";
}
export function getCellLinkProps(item, link, onSelect, linkBuilder) {
    let cellLink = undefined;
    if (linkBuilder) {
        const builtLink = linkBuilder(item);
        cellLink =
            builtLink !== null ? { link: builtLink, role: "link" } : undefined;
    }
    const definedLink = {
        ...link,
        url: link?.url + (link?.linkKey ? item[link.linkKey] : ""),
    };
    if (link?.url) {
        cellLink = { link: definedLink, role: "link" };
    }
    else if (onSelect) {
        cellLink = {
            role: "button",
            onClick: () => onSelect(item),
        };
    }
    return cellLink;
}
export function getDrawerData(item, drawer) {
    if (drawer === undefined ||
        drawer === null ||
        item === undefined ||
        item === null) {
        return undefined;
    }
    return drawer?.nodeKey && item[drawer?.nodeKey];
}
export function getItemTooltipContent(column, values) {
    const formatter = (value) => {
        if (isDefined(value) && column?.tipFormatter) {
            return column?.tipFormatter(value);
        }
        return value || "";
    };
    return formatter(values[column.key]);
}
export function canShowTooltip(itemNode, heading) {
    return (typeof itemNode == "string" ||
        typeof itemNode == "number" ||
        heading.tipFormatter);
}
export const getAlternatingRow = (rowIndex) => {
    if (rowIndex === 0 || !!(rowIndex && !(rowIndex % 2)))
        return "even";
    return "odd";
};
